import { tv } from 'tailwind-variants';

const link = tv({
  base: 'flex items-center justify-center rounded-lg font-semibold border-none shadow-none gap-2',
  variants: {
    color: {
      primary: 'text-blue-700 hover:text-blue-800',
      secondary: 'text-gray-600 hover:text-gray-700'
    },
    destructive: {
      true: ''
    },
    disabled: {
      true: ''
    },
    size: {
      sm: 'h-5 text-sm', // h-20px
      md: 'h-5 text-sm', // h-20px
      lg: 'h-6 text-md', // h-24px
      xl: 'h-6 text-md', //h-24px
      '2xl': 'h-7 w-[164px] text-lg gap-3' // h-28px
    },
    defaultVariants: {
      color: 'primary',
      size: 'md',
      disabled: false
    }
  },
  compoundVariants: [
    {
      destructive: true,
      disabled: false,
      className: 'text-red-700 hover:text-red-800'
    },
    {
      destructive: true,
      disabled: true,
      className: 'text-red-300 hover:text-red-300'
    }
  ]
});

const statusIcon = tv({
  variants: {
    color: {
      primary: 'fill-green-500',
      secondary: 'fill-green-500'
    },
    destructive: {
      true: ''
    },
    disabled: {
      true: 'fill-gray-300'
    }
  },
  compoundVariants: [
    {
      destructive: true,
      disabled: true,
      className: 'fill-red-300'
    },
    {
      color: 'primary',
      destructive: false,
      disabled: true,
      className: 'fill-white'
    }
  ]
});

export { link, statusIcon };
